const DegreesFoundationsZiniaThemes = {
    degree_0: '0',
    degree_30: '30',
    degree_45: '45',
    degree_90: '90',
    degree_180: '180',
};
export { DegreesFoundationsZiniaThemes };
//# sourceMappingURL=degrees-foundations.zinia.themes.js.map